// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"page-title_subtitle__CtrxS","title":"page-title_title__x58lc","titleContainer":"page-title_titleContainer__ufPSp"};